
import AdvancedTabsComponent from "./AdvancedTabs/AdvancedTabs";
import ModalNewAlertComponent from './ModalNewAlert/ModalNewAlert'

export const AdvancedTabs = AdvancedTabsComponent;
export const ModalNewAlert = ModalNewAlertComponent
